import React from 'react'

import { Container } from '@mui/system'

import logo from 'assets/images/sectorLogos/logo-horizontal.svg'
import firstPhoto from 'assets/images/auth/first-photo.png'
import secondPhoto from 'assets/images/auth/2-photo.png'
import thirdPhoto from 'assets/images/auth/3-photo.png'
import fourthPhoto from 'assets/images/auth/4-photo.png'
import { Box, Grid, IconButton } from '@mui/material'
import { MenuIcon } from 'Sui_Icons'
import { SideMenu } from 'components'


export const AuthLayout = ({ children }) => {
    return (
        <Container maxWidth='xl'>
            <Grid container spacing={{ xs: 0, lg: 3 }} >
                <Grid item xs={6} lg={3} order={1} paddingTop={0}>

                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start',
                        justifyContent: 'space-between',
                        height: { lg: '100vh' },
                        maxHeight: { lg: '800px' }
                    }}>
                        <SideMenu />

                        <Box sx={{ maxWidth: '250px', mt: { xs: -5, lg: -7 } }}  >
                            <img style={{ width: '100%' }} src={firstPhoto} />
                        </Box>

                        <Box sx={{ maxWidth: '200px', mt: { lg: 2 }, display: { xs: 'none', lg: 'block' } }}>
                            <img style={{ width: '100%' }} src={secondPhoto} />
                        </Box>

                    </Box>

                </Grid>

                <Grid item xs={12} lg={6} order={{ xs: 3, lg: 2 }} sx={{
                    display: 'flex',
                    alignContent: 'center',
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-evenly',
                        flexDirection: 'column',
                        width: { xs: '90%', lg: '80%' }
                        // background:'red'
                    }}>
                        {children}
                    </Box>

                </Grid>

                <Grid item xs={6} lg={3} order={{ xs: 1, lg: 3 }} paddingTop={0}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: { lg: '100vh' },
                        maxHeight: { lg: '800px' }
                    }}>
                        <Box sx={{ p: { lg: 0 }, m: { lg: 0 }, maxWidth: { xs: '140px', lg: '230px' } }}  >
                            <img style={{ width: '100%' }} src={thirdPhoto} />
                        </Box>

                        <Box sx={{ maxWidth: { xs: '150px', lg: '230px' }, mt: { lg: -7 }, display: { xs: 'none', lg: 'block' } }}  >
                            <img style={{ width: '100%' }} src={fourthPhoto} />
                        </Box>
                    </Box>

                </Grid>

                <Grid item xs={12} sx={{ display: { xs: 'flex', lg: 'none' }, mt: 6, justifyContent: 'space-between', alignItems: 'center', width: '80%' }} order={4}>

                    <Box sx={{ maxWidth: '150px', mx: 2 }}>
                        <img style={{ width: '100%' }} src={secondPhoto} />
                    </Box>

                    <Box sx={{ maxWidth: { xs: '120px', } }}  >
                        <img style={{ width: '100%' }} src={fourthPhoto} />
                    </Box>
                </Grid>



            </Grid>


        </Container>
    )
}
